import moment from 'moment/moment';
import React, {useState, useEffect} from 'react';
import {MenuLateralAA} from '../menuLateralAA/MenuLateralAA';
import {ModalActivarPresupuesto} from '../Presupuestos/ModalActivarPresupuesto';
import {Factura} from './Factura';
import {Moment} from 'moment';
import {HeadFacturas} from './HeadFacturas';
import {ListaFacturas as listFac} from './ListaFacturas';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ContentHistorialFacturas = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Creating a list of objects that will be used to create the Factura component. */
	let lista = listFac();

	/* Creating a state variable called ListaFacturas and a function called setListaFacturas. */
	const [ListaFacturas, setListaFacturas] = useState(lista);

	/* Creating a state variable called TipoNotificaciones and a function called setTipoNotificaciones. */
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);

	/* Creating a state variable called ListaFacturasSeleccionas and a function called
    setListaFacturasSeleccionas. */
	const [ListaFacturasSeleccionas, setListaFacturasSeleccionas] = useState([]);

	/* Creating a state variable called ViewModalExportarFacturas and a function called
    setViewModalExportarFacturas. */
	const [ViewModalExportarFacturas, setViewModalExportarFacturas] = useState(false);

	/* Setting the state of the EstadoActivacion variable to 0. */
	const [EstadoActivacion, setEstadoActiacion] = useState(0);

	/* It closes the activacion modal. */
	const cerrarModalViewModalExportarFacturas = () => {
		setViewModalExportarFacturas(false);
		setEstadoActiacion(1);
	};

	/* It sends a request to the server and sets the state of the component to 1. */
	async function exportarFacturas() {
		setEstadoActiacion(1);
		try {
			let ss = await fetch('https://www.youtube.com/');
		} catch (e) {
			console.error('error envio datos [enviarAceptacion]');
		}
		setEstadoActiacion(2);
		console.log(ListaFacturasSeleccionas);
	}

	const MostrarModalNoHayFacturasSeleccionadas = () => {};

	/**
	 * If the length of the array is greater than 0, then set the viewModalExportarFacturas to true,
	 * otherwise, call the function MostrarModalNoHayFacturasSeleccionadas()
	 */
	const abrirModalExportarFacturas = () => {
		ListaFacturasSeleccionas.length > 0
			? setViewModalExportarFacturas(true)
			: MostrarModalNoHayFacturasSeleccionadas();
	};

	/* A hook that is used to store the state of the component. */
	const [Estado, setEstado] = useState('todas');

	/**
	 * It compares two dates and returns true if the first date is less than the second date
	 */
	const comparadorFechasMenor = (f1, f2) => {
		f1 = f1.split('-');
		let ff1 = [];
		f1.map((element) => {
			ff1.push(parseInt(element));
		});
		f2 = f2.split('/');
		let ff2 = [];
		f2.map((element) => {
			ff2.push(parseInt(element));
		});
		ff2[1] = ff2[1] + 1;
		if (ff2[2] < ff1[0]) {
			return true;
		} else {
			if (ff2[2] > ff1[0]) {
				return false;
			} else {
				if (ff2[1] < ff1[1]) {
					return true;
				} else {
					if (ff2[1] > ff1[1]) {
						return false;
					} else {
						if (ff2[0] <= ff1[2]) {
							return true;
						} else {
							return false;
						}
					}
				}
			}
		}
	};

	/**
	 * It sets the momentInit state to the value passed in.
	 */
	const filtroMomentoInit = (value) => {
		let listaAxu = [];
		ListaFacturas.map((factura) => {
			comparadorFechasMenor(value, factura.peridodoInit)
				? console.log()
				: listaAxu.push(factura);
		});
		setListaFacturas(listaAxu);
	};

	/**
	 * It filters a list of invoices by comparing the payment status, the initial date and the final
	 * date
	 */
	const filtrarFacturasEstado = (value) => {
		let listaAxu1 = listFac();
		let listaAxu2 = [];
		listaAxu1.map((factura) => {
			/*
            console.log("Factura : "+factura.estadoPago)
            console.log("Estado : "+Estado)
            */
			if (value === 'todas') {
				listaAxu2.push(factura);
			} else {
				if (factura.estadoPago === value) {
					listaAxu2.push(factura);
				} else {
					if (factura.estadoPago === value) {
						listaAxu2.push(factura);
					}
				}
			}
		});
		setListaFacturas(listaAxu2);
	};

	/* A hook that is used to store the state of the component. */
	const [MomentInit, setMomentInit] = useState({
		init: '01/01/2022',
	});

	/* A hook that is used to store the state of the component. */
	const [MomentFinal, setMomentFinal] = useState({
		final: '03/02/2022',
	});

	/**
	 * When the user types in the input field, the value of the input field is set to the state of the
	 * component.
	 */
	const handleChangeInit = (event) => {
		setMomentInit({init: event.target.value});
		filtroMomentoInit(event.target.value);
	};

	/**
	 * The function takes an event as an argument, and then sets the state of the final variable to the
	 * value of the event
	 */
	const handleChangeFinal = (event) => {
		setMomentFinal({final: event.target.value});
	};

	/* An array of objects that are used to create the dropdown menu. */
	const optio = [
		{label: 'Pagadas y no pagadas', value: 'todas'},
		{label: 'No pagadas', value: 'noPagado'},
		{label: 'Pagadas', value: 'pagado'},
	];

	const [first, setfirst] = useState('Pagadas y no pagadas');

	/**
	 * When the user changes the value of the select element, set the value of the state variable to
	 * the value of the select element.
	 */
	const handleChangeEstado = (event) => {
		console.log(event);
		if (event.value != first) {
			setfirst(event.value);
			filtrarFacturasEstado(event.value);
		}
	};

	return (
		<div className='ContentHistorialFacturas'>
			{ViewModalExportarFacturas && (
				<ModalActivarPresupuesto
					cerrarModalActivarPresupuesto={cerrarModalViewModalExportarFacturas}
					EstadoActivacion={EstadoActivacion}
					enviarAceptacion={exportarFacturas}
					titulo={'Exportar facturas'}
					mensaje1={'¿Desea exportar en un csv las facturas seleccionadas?'}
					mensaje2={'Facturas exportadas correctamente'}
				/>
			)}
			{
				/* Esta es la posicon del boton qu se ha de estar seleccionado*/
				Usuario.tipo === 'usuarioAdmin' ? (
					<MenuLateralAA seleccionado={3} />
				) : (
					<MenuLateralAB
						seleccionado={1}
						MenuLateralAux={MenuLateralAux}
						chageMenuLateralAux={chageMenuLateralAux}
					/>
				)
			}
			<div className='derContentPresupuestos'>
				<div className='headContentUsuarios head-for-documentos'>
					<div className='superiorHeadContentUsuarios'>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='40'
								height='40'
								fill='currentColor'
								className='bi bi-file-earmark-ruled'
								viewBox='0 0 16 16'
							>
								<path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z' />
							</svg>
						</div>
						<div className='centrador titleHeadHistorialFacturas'>
							Historial Facturas
						</div>
					</div>
					<div className='separador'></div>
					<div className='inferiorHeadContentUsuarios'>
						<div className='derHeadContentUsuarios'>
							<div className='inputHeadContentUsuarios'>
								<div className='labelInputUsuarios'>Fecha de inicio</div>
								<input
									type='date'
									onChange={handleChangeInit}
									value={MomentFinal.init}
								/>
							</div>
							<div className='inputHeadContentUsuarios'>
								<div className='labelInputUsuarios'>Fecha de Finalizacion</div>
								<input
									type='date'
									onChange={handleChangeFinal}
									value={MomentFinal.final}
								/>
							</div>
							<div className='inputHeadContentUsuarios'>
								<div className='labelInputUsuarios'>Estado factura</div>
								<Dropdown
									className='miDropDown'
									options={optio}
									onChange={handleChangeEstado}
									value={first}
									placeholder='Select an option'
								/>
							</div>
						</div>
						<div className='izqheadContentUsuarios centrador'>
							<div
								className='buttonAddUsuarios'
								onClick={abrirModalExportarFacturas}
							>
								<div className='centrador'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='16'
										height='16'
										fill='currentColor'
										className='bi bi-plus-circle-fill'
										viewBox='0 0 16 16'
									>
										<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
									</svg>
								</div>
								<div className='centrador'>Exportar csv</div>
							</div>
						</div>
					</div>
				</div>
				{/*  
                <div className="headFacturas">
                    <div className="superiorHeadFacturas">
                        <div className="izqSuperiorHeadFacturas">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-file-earmark-ruled" viewBox="0 0 16 16">
                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z" />
                                </svg>
                            </div>
                            <div className="centrador titleHeadHistorialFacturas">Historial de Facturas</div>
                        </div>
                        <div className="derSuperiorHeadFacturas">
                            <div className="centrador">
                                <input type="text" />
                            </div>
                            <div className="centrador botonBuscarHistorialFacturas">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className='separador'></div>
                    <div className="medioHeadFacturas">
                        <div className='derMedioHeadFacturas'>
                            <div className='inputFechaFacturas'>
                                <div>Fecha de inicio</div>
                                <input
                                    type="date"
                                    onChange={handleChangeInit}
                                    value={MomentFinal.init}
                                />
                            </div>
                            <div className='inputFechaFacturas'>
                                <div>Fecha finalización</div>

                                <input
                                    type="date"
                                    onChange={handleChangeFinal}
                                    value={MomentFinal.final}
                                />
                            </div>
                            <div className='inputFechaFacturas'>
                                <div>Estado factura</div>
                                <Dropdown
                                    className='miDropDown'
                                    options={optio}
                                    onChange={handleChangeEstado}
                                    value={first}
                                    placeholder="Select an option"
                                />
                            </div>
                        </div>
                        <div className='izqMedioHeadFacturas centrador'>
                            <div className='button'
                                onClick={abrirModalExportarFacturas}
                            >Exportar csv</div>
                        </div>

                    </div>
                </div>
                */}

				<div className='facturas'>
					{
						/* Creating a list of Factura components. */
						ListaFacturas.map((factura) => (
							/*
                            que se puedan seleccionar las tarjetas para la wexportacion en csv
                            */
							<Factura
								key={factura.id}
								fotoFactura={factura.fotoFactura}
								nombreCliente={factura.nombreCliente}
								fechaFacturacion={factura.fechaFacturacion}
								peridodoInit={factura.peridodoInit}
								peridoFinal={factura.peridoFinal}
								numeroFactura={factura.numeroFactura}
								tipoServicio={factura.tipoServicio}
								horasDias={factura.horasDias}
								precioHora={factura.precioHora}
								tipoTarjeta={factura.tipoTarjeta}
								numTarjeta={factura.numTarjeta}
								cargdoAdicionales={factura.cargdoAdicionales}
								totalFactura={factura.totalFactura}
								pagoAgencia={factura.pagoAgencia}
								estadoPago={factura.estadoPago}
								ListaFacturasSeleccionas={ListaFacturasSeleccionas}
								setListaFacturasSeleccionas={setListaFacturasSeleccionas}
							/>
						))
					}
				</div>
			</div>
		</div>
	);
};
